export const INTERSECTION_THRESHOLD = 0.35;

// In milliseconds
export const EXIT_TIMEOUT = 300000;

export const ADDRESS_UNAVAILABLE = 'Address Unavailable';
